import { DeleteModalService } from './../../services/delete-modal.service';
import { DeleteModalComponent } from './../../../shared/delete-modal/delete-modal.component';
import { StoresModalComponent } from './../../../shared/stores-modal/stores-modal.component';
import { MasterService } from './../../services/master.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { PaginationInstance } from 'ngx-pagination';
import {CommonAlertService} from "../../../services/common-alert.service";

@Component({
  selector: 'app-stores',
  templateUrl: './stores.component.html',
  styleUrls: ['./stores.component.scss']
})
export class StoresComponent implements OnInit {

  public stores: any;
  public filter: any;
  // tslint:disable-next-line:variable-name
  total_count: number;
  // tslint:disable-next-line:variable-name
  current_page: number;
  // tslint:disable-next-line:variable-name
  last_page: number;
  // tslint:disable-next-line:variable-name
  per_page: number;
  stockPageId = 'stockPageId';
  pageEvent: PageEvent;
  public selectedIndex = 0;
  public searchBy: any = 0;
  public searchTxt: any;
  placeHolder: any = 'Search By Store Name';

  @Input() id: string;
  @Input() maxSize: number;
  @Output() pageChange: EventEmitter<number>;
  itemToBePushed: any;

  public config: PaginationInstance = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1
  };

  public childMessage = 'listing_pagination';
  bool = false;
  public viewPermission = false;
  public addPermission = false;
  public editPermission = false;
  public deletePermission = false;
  constructor(public masterservice: MasterService, public dialog: MatDialog, public deleteModalService: DeleteModalService, public commonAlertService: CommonAlertService) { }

  ngOnInit() {
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.viewPermission = this.addPermission = this.editPermission = this.deletePermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      // tslint:disable-next-line:triple-equals max-line-length
      if (roles['more.stores.view'] == 1 || roles['more.stores.add'] == 1 || roles['more.stores.edit'] == 1 || roles['more.stores.delete'] == 1) {
        this.viewPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['more.stores.add'] == 1) {
        this.addPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['more.stores.edit'] == 1) {
        this.editPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['more.stores.delete'] == 1) {
        this.deletePermission = true;
      }
    }
    this.filter = {
      token: localStorage.getItem('token')
    };
    this.getStoresData();
  }

  getStoresData() {

    const page = 1;
    this.masterservice.getIndex('/stores/index', this.filter).subscribe(res => {
      // @ts-ignore
      this.stores = res.data.items;
      // @ts-ignore
      this.total_count = res.data.total;
      // @ts-ignore
      this.last_page = res.data.last_page;
      // @ts-ignore
      this.per_page      = res.data.per_page;
      this.itemToBePushed = (this.last_page * this.per_page) - this.total_count;
      this.total_count = this.total_count + (this.last_page * this.per_page - this.total_count);
      // @ts-ignore
      this.current_page = res.data.current_page;
      this.bool = true;
      const newData = {
       warehouse_name: '',
       location_name: '',
       name: '',
       antenna_name: ''
     };
      if (this.stores.length < this.per_page) {
        for ( let i = 0; i < this.itemToBePushed ; i++) {
          this.stores.push(newData);
        }
      }
      // @ts-ignore
      if(res.data.total == 0){
       this.commonAlertService.showEmptyMsg({message: 'No Details Found.'})
      }
    });

  }

  getSearchValue() {
    if (this.searchBy) {
      switch (this.searchBy) {
        case '0':
          this.placeHolder = 'Search By Store Name';
          break;
        case '1':
          this.placeHolder = 'Search By Warehouse Name';
          break;
        case '2':
          this.placeHolder = 'Search by City Name';
          break;
        case '3':
          this.placeHolder = 'Search by Antenna Name';
          break;
          default: this.placeHolder = 'Search By Store Name';
      }
    }
  }

  openDialog(): void {
      const dialogRef = this.dialog.open(StoresModalComponent, {
      minWidth: '30vw',
      minHeight: '20vh',
      disableClose: true
    }).afterClosed().subscribe(() => this.getStoresData());
  }

    editDialog(i) {
      const editId = this.stores[i].id;
      const encID  = this.stores[i].enc_id;
      // tslint:disable-next-line:triple-equals
      if ( editId != undefined && encID != undefined) {
      const dialogRef = this.dialog.open(StoresModalComponent, {
        minWidth: '30vw',
        minHeight: '20vh',
        disableClose: true,
        data: {
          edit: {
            editID: editId,
            encryId: encID
          }
        }
      }).afterClosed().subscribe(() => this.getStoresData());
    }
  }

  selectRow(index: number) {
    this.selectedIndex = index;
  }

  doSearch(): void {

  if (this.searchBy != null) {
      switch (this.searchBy) {
         case '0':
           Object.assign(this.filter, {search: { type: 'str', field: 'stores.name', text: this.searchTxt}});
           break;
        case '2':
          Object.assign(this.filter, {search: { type: 'str', field: 'locations.name', text: this.searchTxt}});
          break;
        case '3':
          Object.assign(this.filter, {search: { type: 'str', field: 'antennas.name', text: this.searchTxt}});
          break;
        default:
          Object.assign(this.filter, {search: { type: 'str', field: 'stores.name', text: this.searchTxt}});
      }
    }
  this.getStoresData();
  }

   doRefresh(): void {
     this.searchTxt = null;
     this.filter = {
       token: localStorage.getItem('token')
     };
     this.getStoresData();
  }

  doPaginate(e): void {
    Object.assign(this.filter, {page: e});
    this.getStoresData();
  }

  deleteDialog(i): void {
    this.deleteModalService.openModal({
      token: localStorage.getItem('token'),
    id: this.stores[i].id,
    encId: this.stores[i].enc_id,
    deleteUrl: '/stores/destroy'
    });

    this.deleteModalService.closed.subscribe(() => {
      this.getStoresData();
    });
  }
}

